module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ArticleList":{"pagination":{"buttonLoadMore":{"ariaLabel":"Zobrazit další články","text":"Další články"}}}},"en":{"ArticleList":{"pagination":{"buttonLoadMore":{"ariaLabel":"View more articles ","text":"More articles"}}}}}')
  delete Component.options._Ctor
}
